const HistoryColumns = [
  {
    title: "Change DateTime",
    field: "changeDateTime",
    locked: false,
    filter: "date",
    format: "DD/MM/yyyy hh:mm A",
    editor: "date",
    width: "auto",
    show: true,
  },

  {
    title: "Department", //"DepartmentDivSec",
    field: "Department",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Health Deduction Class",
    field: "HealthDeductionClass",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Health Plan",
    field: "HealthPlan",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Dental Deduction Class",
    field: "HealthDeductionClass",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Dental Plan",
    field: "HealthPlan",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
];

export default HistoryColumns;
